export default __webpack_public_path__ + "static/media/birdrock.9a05f4c9.jpeg";